import { css } from 'styled-components';
export var overlay = /*#__PURE__*/css(["background-color:rgba(2,24,40,0.2);position:fixed;top:var(--overlayTop);left:0;right:0;bottom:0;z-index:2;"]);